import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Checkbox,
  Input,
  Label,
  TextArea
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardSurgicalSafetyChecklistTimeoutUX = (props: any) => {
    return(
      <div
        id="CardSurgicalSafetyChecklistTimeoutUX-div-0"
        style={{ margin: "15px", padding: "20px", backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-159"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-160"
              style={{ fontWeight: "bold", fontSize: "18px" }}>
              {props.languageUX === "en" ? "Surgical Safety Checklist - Time out" : "Surgical Safety Checklist - Time out"}
            </label>
            <Label
              id="CardSurgicalSafetyChecklistTimeoutUX-Label-161"
              style={{display: props.status? "": "none"}}>
              {props.status}
            </Label>
          </div>
          <hr
            id="CardSurgicalSafetyChecklistTimeoutUX-hr-4">
          </hr>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-77"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-78"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-79">
              {props.languageUX === "en" ? "All team member have introduced themselves" : "สมาชิกทีมทุกคนแนะนำตัวเรียบร้อย"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-80"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.team_introduce}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-81"
            label={props.surgicalSafety?.data?.team_introduce ? "Yes" : "No"}
            onChange={props.handleChangeValue("team_introduce")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-82"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-83"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-84">
              {props.languageUX === "en" ? "Patient Identify/Site/Procedure confirmed" : "ยืนยันตัวผู้ป่วย  ตำแหน่ง และหัตถการเรียบร้อยแล้ว"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-85"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.patient_identify}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-86"
            label={props.surgicalSafety?.data?.patient_identify ? "Yes" : "No"}
            onChange={props.handleChangeValue("patient_identify")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          className="ui form"
          id="CardSurgicalSafetyChecklistTimeoutUX-div-87"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-88"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-89">
              {props.languageUX === "en" ? "Antibiotic prophylaxis" : "การให้ยาปฏิชีวนะเพื่อป้องกันการติดเชื้อ"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-90"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.antibiotic}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-91"
            label={props.surgicalSafety?.data?.antibiotic ? "Applicable" : "Not applicable"}
            onChange={props.handleChangeValue("antibiotic")}
            toggle={true}>
          </Checkbox>
          <TextArea
            id="CardSurgicalSafetyChecklistTimeoutUX-TextArea-163"
            name="antibioticRemark"
            onChange={props.handleChangeValue("antibioticRemark")}
            style={{ width: "30%", margin: "0px 30px", ...(!props.surgicalSafety?.data?.antibiotic && { display: "none" }) }}
            value={props.surgicalSafety?.data?.antibioticRemark}>
          </TextArea>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-92"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-93"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-94">
              {props.languageUX === "en" ? "Essential Imaging" : "การตรวจทางวินิจฉัยทางรังสีที่จำเป็น"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-95"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.surgicalSafety?.data?.essential_imaging}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-96"
            label={props.surgicalSafety?.data?.essential_imaging ? "Yes" : "No"}
            onChange={props.handleChangeValue("essential_imaging")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-97"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-99"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Anticipated Critical Events" : "ภาวะวิกฤติที่คาดว่าจะเกิดขึ้น"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.critical_events}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-101"
            label={props.surgicalSafety?.data?.critical_events ? "Yes" : "No"}
            onChange={props.handleChangeValue("critical_events")}
            toggle={true}>
          </Checkbox>
        </div>
        <hr
          id="CardSurgicalSafetyChecklistTimeoutUX-hr-125">
        </hr>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-126"
          style={{ display: "flex", padding: "15px 0px 5px", color: "#0C5185", fontWeight: "bold" }}>
          {props.languageUX === "en" ? "To Nursing Team :" : "ถึง ทีมพยาบาล :"}
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-127"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-128"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Has sterility (including indicator results) been confined" : "ตรวจสอบความปราศจากเชื้อของอุปกรณ์เรียบร้อย (รวมตัวชี้วัด)"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.has_sterility}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-129"
            label={props.surgicalSafety?.data?.has_sterility ? "Yes" : "No"}
            onChange={props.handleChangeValue("has_sterility")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-130"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-131"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Are there equipment issue or any concerns" : "ตรวจสอบว่ามีปัญหาอุปกรณ์ หรือข้อกังวลใด ๆ หรือไม่"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.equipment_issue}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-132"
            label={props.surgicalSafety?.data?.equipment_issue ? "Yes" : "No"}
            onChange={props.handleChangeValue("equipment_issue")}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-133"
          style={{ display: "flex", padding: "15px 0px 5px", color: "#0C5185", fontWeight: "bold" }}>
          {props.languageUX === "en" ? "To Surgeon :" : "ถึง ศัลยแพทย์ :"}
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-134"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-135"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "What are Critical or non-routine step?" : "ขั้นตอนใดบ้างที่สำคัญ หรือไม่ใช่ขั้นตอนตามปกติ"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.is_critical_step}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-136"
            label={props.surgicalSafety?.data?.is_critical_step ? "Yes" : "No"}
            onChange={props.handleChangeValue("is_critical_step")}
            toggle={true}>
          </Checkbox>
          <Input
            disabled={props.surgicalSafety?.data?.is_critical_step ? false : true}
            id="CardSurgicalSafetyChecklistTimeoutUX-Input-137"
            onChange={props.handleChangeValue("critical_step")}
            style={{ width: "50%", marginLeft: "20px" }}
            value={props.surgicalSafety?.data?.critical_step}>
          </Input>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-138"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-139"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "How long will the case take" : "การผ่าตัดนี้จะใช้เวลานานเท่าไร"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.is_long}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-140"
            label={props.surgicalSafety?.data?.is_long ? "Yes" : "No"}
            onChange={props.handleChangeValue("is_long")}
            toggle={true}>
          </Checkbox>
          <Input
            disabled={props.surgicalSafety?.data?.is_long ? false : true}
            id="CardSurgicalSafetyChecklistTimeoutUX-Input-141"
            onChange={props.handleChangeValue("long")}
            style={{ width: "50%", marginLeft: "20px" }}
            value={props.surgicalSafety?.data?.long}>
          </Input>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-142"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-143"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "What is the anticipate blood loss" : "ประเมินปริมาณเลือดที่คาดว่าจะสูญเสีย"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.is_blood_loss}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-144"
            label={props.surgicalSafety?.data?.is_blood_loss ? "Yes" : "No"}
            onChange={props.handleChangeValue("is_blood_loss")}
            toggle={true}>
          </Checkbox>
          <Input
            disabled={props.surgicalSafety?.data?.is_blood_loss ? false : true}
            id="CardSurgicalSafetyChecklistTimeoutUX-Input-145"
            onChange={props.handleChangeValue("blood_loss")}
            style={{ width: "50%", marginLeft: "20px" }}
            value={props.surgicalSafety?.data?.blood_loss}>
          </Input>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-146"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardSurgicalSafetyChecklistTimeoutUX-label-147"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Are there any patient-specific concerns" : "มีข้อกังวลเฉพาะผู้ป่วยรายนี้หรือไม่"}
          </label>
          <Checkbox
            checked={props.surgicalSafety?.data?.is_specific_concern}
            id="CardSurgicalSafetyChecklistTimeoutUX-Checkbox-148"
            label={props.surgicalSafety?.data?.is_specific_concern ? "Yes" : "No"}
            onChange={props.handleChangeValue("is_specific_concern")}
            toggle={true}>
          </Checkbox>
          <Input
            disabled={props.surgicalSafety?.data?.is_specific_concern ? false : true}
            id="CardSurgicalSafetyChecklistTimeoutUX-Input-149"
            onChange={props.handleChangeValue("specific_concern")}
            style={{ width: "50%", marginLeft: "20px" }}
            value={props.surgicalSafety?.data?.specific_concern}>
          </Input>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-150"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-151"
            style={{ fontWeight: "bold", width: "30%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-152">
              {props.languageUX === "en" ? "Time out" : "Time out"}
            </label>
            <label
              id="CardSurgicalSafetyChecklistTimeoutUX-label-153"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <DateTextBox
            id="CardSurgicalSafetyChecklistTimeoutUX-DateTextBox-154"
            onChange={props.handleChangeDate("incision_date")}
            value={props.surgicalSafety?.data?.incision_date}>
          </DateTextBox>
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-162"
            style={{ marginLeft: "10px" }}>
            {props.timeTextBox}
          </div>
        </div>
        <div
          id="CardSurgicalSafetyChecklistTimeoutUX-div-59"
          style={{ height: "55px", paddingTop: "15px", display: "flex", justifyContent: "flex-end" }}>
          
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-156">
            {props.buttonSave}
          </div>
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-157"
            style={{margin: "0px 10px"}}>
            {props.buttonConfirm}
          </div>
          <div
            id="CardSurgicalSafetyChecklistTimeoutUX-div-158">
            {props.buttonUnconfirm}
          </div>
        </div>
      </div>
    )
}


export default CardSurgicalSafetyChecklistTimeoutUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\", padding: \"20px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-hr-4"
        }
      },
      "seq": 159,
      "void": true
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\", display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "สมาชิกทีมทุกคนแนะนำตัวเรียบร้อย",
          "valueEN": "All team member have introduced themselves"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-79"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Checkbox",
      "parent": 77,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.team_introduce"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-81"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.team_introduce ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"team_introduce\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันตัวผู้ป่วย  ตำแหน่ง และหัตถการเรียบร้อยแล้ว",
          "valueEN": "Patient Identify/Site/Procedure confirmed"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-84"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Checkbox",
      "parent": 82,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.patient_identify"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-86"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.patient_identify ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"patient_identify\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "การให้ยาปฏิชีวนะเพื่อป้องกันการติดเชื้อ",
          "valueEN": "Antibiotic prophylaxis"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-89"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-90"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Checkbox",
      "parent": 87,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.antibiotic"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-91"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.antibiotic ? \"Applicable\" : \"Not applicable\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"antibiotic\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจทางวินิจฉัยทางรังสีที่จำเป็น",
          "valueEN": "Essential Imaging"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-94"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-95"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Checkbox",
      "parent": 92,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.essential_imaging"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-96"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.essential_imaging ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"essential_imaging\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาวะวิกฤติที่คาดว่าจะเกิดขึ้น",
          "valueEN": "Anticipated Critical Events"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-99"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Checkbox",
      "parent": 97,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.critical_events"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-101"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.critical_events ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"critical_events\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-hr-125"
        }
      },
      "seq": 102,
      "void": true
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง ทีมพยาบาล :",
          "valueEN": "To Nursing Team :"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", padding: \"15px 0px 5px\", color: \"#0C5185\", fontWeight: \"bold\" }"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": "ตรวจสอบความปราศจากเชื้อของอุปกรณ์เรียบร้อย (รวมตัวชี้วัด)",
          "valueEN": "Has sterility (including indicator results) been confined"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-128"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Checkbox",
      "parent": 127,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.has_sterility"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-129"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.has_sterility ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"has_sterility\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "label",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "ตรวจสอบว่ามีปัญหาอุปกรณ์ หรือข้อกังวลใด ๆ หรือไม่",
          "valueEN": "Are there equipment issue or any concerns"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-131"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "Checkbox",
      "parent": 130,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.equipment_issue"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-132"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.equipment_issue ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"equipment_issue\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง ศัลยแพทย์ :",
          "valueEN": "To Surgeon :"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", padding: \"15px 0px 5px\", color: \"#0C5185\", fontWeight: \"bold\" }"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "label",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "ขั้นตอนใดบ้างที่สำคัญ หรือไม่ใช่ขั้นตอนตามปกติ",
          "valueEN": "What are Critical or non-routine step?"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-135"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "Checkbox",
      "parent": 134,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_critical_step"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-136"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_critical_step ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"is_critical_step\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "Input",
      "parent": 134,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_critical_step ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Input-137"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"critical_step\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.critical_step"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "การผ่าตัดนี้จะใช้เวลานานเท่าไร",
          "valueEN": "How long will the case take"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "Checkbox",
      "parent": 138,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_long"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-140"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_long ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"is_long\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "Input",
      "parent": 138,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_long ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Input-141"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"long\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.long"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "label",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเมินปริมาณเลือดที่คาดว่าจะสูญเสีย",
          "valueEN": "What is the anticipate blood loss"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-143"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Checkbox",
      "parent": 142,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_blood_loss"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-144"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_blood_loss ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"is_blood_loss\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Input",
      "parent": 142,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_blood_loss ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Input-145"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"blood_loss\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.blood_loss"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "label",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": "มีข้อกังวลเฉพาะผู้ป่วยรายนี้หรือไม่",
          "valueEN": "Are there any patient-specific concerns"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-147"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "Checkbox",
      "parent": 146,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_specific_concern"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Checkbox-148"
        },
        "label": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_specific_concern ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"is_specific_concern\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "Input",
      "parent": 146,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.is_specific_concern ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Input-149"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"specific_concern\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", marginLeft: \"20px\" }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.specific_concern"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-151"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"30%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "label",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "Time out",
          "valueEN": "Time out"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-152"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "label",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-153"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 154,
      "name": "DateTextBox",
      "parent": 150,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-DateTextBox-154"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"incision_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.incision_date"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-156"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-157"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 158,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-158"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-159"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "label",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "Surgical Safety Checklist - Time out",
          "valueEN": "Surgical Safety Checklist - Time out"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-label-160"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "Label",
      "parent": 159,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-Label-161"
        },
        "name": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.status? \"\": \"none\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "code",
          "value": "props.timeTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "TextArea",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSurgicalSafetyChecklistTimeoutUX-TextArea-163"
        },
        "name": {
          "type": "value",
          "value": "antibioticRemark"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"antibioticRemark\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"30%\", margin: \"0px 30px\", ...(!props.surgicalSafety?.data?.antibiotic && { display: \"none\" }) }"
        },
        "value": {
          "type": "code",
          "value": "props.surgicalSafety?.data?.antibioticRemark"
        }
      },
      "seq": 163,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSurgicalSafetyChecklistTimeoutUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
